var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-space-consumer-gift-card-header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('components.account_space_consumer_gift_card_header.title')))])])}
var staticRenderFns = []

export { render, staticRenderFns }